<template>
  <div>
    <el-card header="活动信息" class="box-card">
      <el-form :model="formData" :rules="rules" ref="dataForm" label-width="100px">
        <el-form-item label="活动名称" prop="title">
          <el-input v-model="formData.title" />
        </el-form-item>
        <el-form-item label="封面图片" prop="icon">
          <image-upload v-model="formData.icon" />
        </el-form-item>
        <el-row>
          <el-col :span="11">
            <el-form-item label="开始日期" prop="startDate">
              <el-date-picker :clearable="false" :editable="false" v-model="start" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="2">&nbsp;</el-col>
          <el-col :span="11">
            <el-form-item label="结束日期" prop="endDate">
              <el-date-picker :clearable="false" :editable="false" v-model="end" type="date" placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="活动正文" prop="content">
          <ckeditor v-model="formData.content"></ckeditor>
        </el-form-item>
        <el-form-item label="链接地址" prop="url">
          <el-input size="small" v-model="formData.url"></el-input>
        </el-form-item>
        <el-form-item label="发布日期" prop="publishDate">
          <el-date-picker  disabled :clearable="false" :editable="false" v-model="formData.publishDate" type="date" placeholder="选择日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label=" ">
          <el-button type="info" @click="dialogVisible=true">预览</el-button>
          <el-button type="warning" @click="submitForm(false)">保存</el-button>
          <el-button type="success" @click="submitForm(true)">发布</el-button>
          <el-button @click="cancel">取消</el-button>
        </el-form-item>
      </el-form>
    </el-card>
    <el-dialog title="" :visible.sync="dialogVisible">
      <ActivityView :activity="formData"/>
    </el-dialog>
  </div>
</template>
<script>
import Moment from 'moment'
import ActivityView from './View'

export default {
  data () {
    return {
      dialogVisible: false,
      formData: {
        id: undefined,
        title: '',
        icon: '',
        startDate: Moment().format('YYYY-MM-DD'),
        endDate: Moment().add(1, 'days').format('YYYY-MM-DD'),
        content: '',
        url: '',
        publishDate: ''
      },
      rules: {
        title: [{ required: true, type: 'string', message: '请选择填写名称', trigger: 'blur' }],
        icon: [{ required: true, message: '请选择封面图片', trigger: 'change' }],
        startDate: [{ required: true, message: '请选择开始日期', trigger: 'change' }],
        endDate: [{ required: true, message: '请选择结束日期', trigger: 'change' }]
      }
    }
  },
  created: function () {
    this.formData.id = this.$route.query.id
    if (this.formData.id) { this.fetchData() }
  },
  mounted: function () {
  },
  methods: {
    fetchData () {
      var that = this
      that.api.activity.get({ id: that.formData.id }).then(response => {
        if (response.data.success) {
          Object.assign(that.formData, response.data.result)
        }
      })
    },
    submitForm (publish) {
      var that = this
      that.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let params = Object.assign({}, that.formData)
          if (publish && !this.formData.publishDate) { params.publishDate = Moment().format('YYYY-MM-DD') }
          that.api.activity.save(params).then(function (response) {
            if (response.data.success) {
              that.$router.push({ path: 'list' })
            }
          })
        } else {
          return false
        }
      })
    },
    resetForm () {
      this.$refs['dataForm'].resetFields()
    },
    cancel () {
      this.$router.go(-1)
    }
  },
  computed: {
    start: {
      get: function () {
        return this.formData.startDate
      },
      set: function (newValue) {
        this.formData.startDate = Moment(newValue).format('YYYY-MM-DD')
      }
    },
    end: {
      get: function () {
        return this.formData.endDate
      },
      set: function (newValue) {
        this.formData.endDate = Moment(newValue).format('YYYY-MM-DD')
      }
    }
  },
  components: {
    ActivityView
  }
}
</script>
<style scoped>

</style>



// WEBPACK FOOTER //
// Edit.vue?42d31c0f